import { useRef } from "react"
import { RequiredAsterisk } from "../required-asterisk"
import { notifyDropdownOpen } from "../../../hooks/use-cached-fetch"

interface FromDropdownProps {
    keyName: string
    label: string
    isRequired?: boolean
    className?: string
    options: { id: number | string, name: string }[]
    value: number | string
    onSelectValue: (e: React.ChangeEvent<HTMLSelectElement>) => void
    onAddBtn?: null | (() => void)
    hideBlankOption?: boolean
    isDisabled?: boolean
    onOpen?: () => void
    dropdownRefreshScope?: string
}

export const FromDropdown: React.FC<FromDropdownProps> = (
    { keyName, label, isRequired = true, className="", options, value, onSelectValue, onAddBtn, hideBlankOption, isDisabled = false, onOpen, dropdownRefreshScope }
) => {
    const mbClassName = className?.includes('end-section')? "mb": ""
    const openNotifiedRef = useRef(false)

    const notifyOpen = () => {
        if (isDisabled || openNotifiedRef.current) return
        openNotifiedRef.current = true
        onOpen?.()
        notifyDropdownOpen(dropdownRefreshScope)
    }

    const resetOpenNotification = () => {
        openNotifiedRef.current = false
    }

    return <>
        <div className={mbClassName}>
            <label htmlFor={keyName}>{label}</label>
            {isRequired && <RequiredAsterisk />}
        </div>
        <select className={className} name={keyName} id={keyName} onChange={onSelectValue} value={value} disabled={isDisabled} onMouseDown={notifyOpen} onFocus={notifyOpen} onBlur={resetOpenNotification}>
            {!hideBlankOption && <option value=""></option>}
            {options.map((option) => {
                return <option key={option.id} value={option.id}>{option.name}</option>
            })}
        </select>
        {onAddBtn && <button className={`add-btn ${mbClassName}`} title="Add" onClick={onAddBtn}>+</button>}
        {!onAddBtn && !className?.includes('span-2') && <span className={mbClassName}></span>}
    </>
}
